import React, { useEffect, useState } from "react";
import axiosClient from "../api/axiosClient";
import { useNavigate } from "react-router-dom";

const Projects = () => {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [apiError, setApiError] = useState("");
    const [deletingId, setDeletingId] = useState(null);
    
    const navigate = useNavigate();
    
    useEffect(() => {
        fetchProjects();
    }, []);
    
    const fetchProjects = async () => {
        setLoading(true);
        setApiError("");
        try {
            const res = await axiosClient.get("/projects");
            setProjects(res.data.data || []);
        } catch (err) {
            setApiError("Failed to load projects.");
        } finally {
            setLoading(false);
        }
    };
    
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this project?")) return;
        setDeletingId(id);
        try {
            await axiosClient.delete(`/projects/${id}`);
            setProjects(projects.filter((project) => project.id !== id));
        } catch (err) {
            alert("Failed to delete project.");
        } finally {
            setDeletingId(null);
        }
    };
    
    const handleEdit = (id) => {
        navigate(`/projects/edit/${id}`);
    };
    
    return (
        <div className="container mt-4" style={{ maxWidth: "1100px" }}>
            <h2 className="mb-4">Projects</h2>
            
            {apiError && <div className="alert alert-danger">{apiError}</div>}
            
            <div className="mb-3 text-end">
                <button
                    className="btn btn-primary"
                    onClick={() => navigate("/projects/create")}
                >
                    + Create New Project
                </button>
            </div>
            
            <div className="table-responsive">
                <table className="table table-striped align-middle">
                    <thead>
                    <tr>
                        <th>Title</th>
                        <th>Slug</th>
                        <th>Status</th>
                        <th>Description</th>
                        <th>Created</th>
                        <th>Image</th>
                        <th>URL</th>
                        <th style={{ width: 140 }}>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan={8} className="text-center">
                                Loading...
                            </td>
                        </tr>
                    ) : projects.length === 0 ? (
                        <tr>
                            <td colSpan={8} className="text-center">
                                No projects found.
                            </td>
                        </tr>
                    ) : (
                        projects.map((project) => (
                            <tr key={project.id}>
                                <td>{project.title}</td>
                                <td>{project.slug}</td>
                                <td>
                                        <span className={project.status === "published" ? "badge bg-success" : "badge bg-secondary"}>
                                            {project.status}
                                        </span>
                                </td>
                                <td>
                                    {project.description
                                        ? project.description.slice(0, 40) + (project.description.length > 40 ? "..." : "")
                                        : <span className="text-muted">No description</span>
                                    }
                                </td>
                                <td>
                                    {project.createdAt
                                        ? new Date(project.createdAt).toLocaleString()
                                        : ""}
                                </td>
                                <td>
                                    {project.featuredImage && (
                                        <img
                                            src={project.featuredImage}
                                            alt={project.title}
                                            style={{ maxWidth: 60, maxHeight: 36, objectFit: "cover" }}
                                        />
                                    )}
                                </td>
                                <td>
                                    {project.projectUrl ? (
                                        <a href={project.projectUrl} target="_blank" rel="noopener noreferrer">
                                            Visit
                                        </a>
                                    ) : (
                                        <span className="text-muted">No link</span>
                                    )}
                                </td>
                                <td>
                                    <button
                                        className="btn btn-sm btn-outline-primary me-2"
                                        onClick={() => handleEdit(project.id)}
                                    >
                                        Edit
                                    </button>
                                    <button
                                        className="btn btn-sm btn-outline-danger"
                                        onClick={() => handleDelete(project.id)}
                                        disabled={deletingId === project.id}
                                    >
                                        {deletingId === project.id ? "Deleting..." : "Delete"}
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Projects;
